import { render, staticRenderFns } from "./location-search-ship.vue?vue&type=template&id=3fa658d1&scoped=true"
import script from "./location-search-ship.vue?vue&type=script&lang=js"
export * from "./location-search-ship.vue?vue&type=script&lang=js"
import style0 from "./location-search-ship.vue?vue&type=style&index=0&id=3fa658d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa658d1",
  null
  
)

export default component.exports